import { render } from "./ModelItemComponent.vue?vue&type=template&id=07d7c894&scoped=true"
import script from "./ModelItemComponent.vue?vue&type=script&lang=js"
export * from "./ModelItemComponent.vue?vue&type=script&lang=js"

import "./ModelItemComponent.vue?vue&type=style&index=0&id=07d7c894&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07d7c894"]])

export default __exports__